function getTotalWinsForLevel(level) {
	// Use the same gradual win curve for every level.
	const levelsGained = level - 1;
	return Math.ceil(0.9 * Math.pow(levelsGained, 1.5) + levelsGained);
}

function getWinsForNextLevel(level) {
	return getTotalWinsForLevel(level + 1) - getTotalWinsForLevel(level);
}

export function updateLevel(userdata) {
	const wins = userdata.stats?.You?.All?.win?.sum ?? 0;
	userdata.level = userdata.level ?? 1;

	if (userdata.lastProcessedWins == null) {
		// Start tracking now; historical wins do not award levels or progress.
		userdata.winsIntoLevel = 0;
		userdata.winsRequired = getWinsForNextLevel(userdata.level);
	} else {
		// A stats reset moves the checkpoint without removing earned progress.
		userdata.winsIntoLevel += Math.max(0, wins - userdata.lastProcessedWins);
	}
	userdata.lastProcessedWins = wins;

	while (userdata.winsIntoLevel >= userdata.winsRequired) {
		userdata.winsIntoLevel -= userdata.winsRequired;
		userdata.level++;
		// Freeze this target until completed, even if the formula changes later.
		userdata.winsRequired = getWinsForNextLevel(userdata.level);
	}
}
